export default ['MD/DO', 'NP', 'PA', 'RN'];